/**
* @file 战队-首页
* @author 余凯
*/

import React from 'react'
import { Tabs, Progress, Button, Modal, Table, Form, Input, message } from 'antd'
import './index.less'
import { connect } from 'react-redux'

import Dict from '@/utils/dict'
import Actions from '@/apis/team'

import Medal1000 from '../../img/1000.png'
import Medal1001 from '../../img/1001.png'
import Medal1002 from '../../img/1002.png'
import Medal1003 from '../../img/1003.png'
import Medal1004 from '../../img/1004.png'
import Medal1005 from '../../img/1005.png'
import Medal1006 from '../../img/1006.png'

const medalObj = {
  10003: Medal1000,
  10004: Medal1001,
  10005: Medal1002,
  10006: Medal1003,
  10000: Medal1004,
  10001: Medal1005,
  10002: Medal1006,
}

const { confirm } = Modal;

const { ROLES, ROLES_STR } = Dict
const { CAPTAIN, VICE_CAPTAIN, ELITE, ORDINARY, NONE } = ROLES

const { TextArea } = Input;

const { TabPane } = Tabs;
const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 14 },
};
const formTailLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 8, offset: 7 },
};
@Form.create()
@connect(
  state => state.teamReducer,

)
class Info extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      visible: false,
      visibleForm: false,
      teamInfo: {},
      rankList: [],
      data: [],
      rewardList: [],
      columns: [
        {
          title: '物品名称',
          dataIndex: 'item_name',
          // "width": 150,
        },
        {
          title: '物品数量',
          dataIndex: 'item_count',
        },
        {
          title: '领取',
          align: 'center',
          render: (action, record) => (
            <Button
              onClick={() => this.handleReceive(record.gameteam_member_reward_id)}
              type="primary"
              shape="round"
              size="small">
              领取
            </Button>
          )
        },
      ]
    }
  }

  callback(key) {
  }

  showModal = async () => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
    }
    const res = await Actions.getMemberReward(params)
    if (res.code == 200) {
      this.setState({
        visible: true,
        rewardList: res.data
      });
    }
  };

  handleReceive = async id => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      gameteam_member_reward_id: id
    }
    const res = await Actions.postMemberReward(params)

    if (res.code == 200) {
      message.success('领取成功')

      Actions.getMemberReward({
        id: this.props.userInfo.game_team_id,
        game_id: this.props.game,
      }).then(res => {
        if (res.code == 200) {
          this.setState({
            rewardList: res.data
          });
        }
      })
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {
          id: this.props.id,
          game_id: this.props.game,
          type: 'join',
          ...values
        }
        Actions.joinTeam(params).then(res => {
          if (res.code == 200) {
            this.setState({
              visibleForm: false
            })
            message.success('申请成功，请等待审核')
          }
        })
      }
    });
  };

  getData = () => {
    setTimeout(async () => {
      const params = {
        id: this.props.id,
        game_id: this.props.game
      }
      Actions.getTeamDetail(params).then(res => {
        if (res.code == 200) {
          this.setState({
            teamInfo: res.data
          })
        }
      })

      const rankParams = {
        id: this.props.id,
        game_id: this.props.game,
        type: 1,
        page_size: 10
      }
      Actions.getTeamRank(rankParams).then(res => {
        if (res.code == 200) {
          this.setState({
            rankList: res.data.list
          })
        }
      })
    }, 0)
  }

  componentDidMount() {
    const data = [];
    for (let i = 1; i < 100; i++) {
      data.push({
        key: i,
        id: i,
        type: '三生三世',
        time: '2020-05-12',
        action: 0,
        // "address": `London, Park Lane no. ${i}`,
      });
    }
    this.props.otherTeam && this.getData()
    // this.setState({
    //   data
    // })
  }

  handleExitTeam = () => {
    const _this = this
    confirm({
      title: '退出战队',
      content: '确认退出战队吗？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        const params = {
          id: _this.props.userInfo.game_team_id,
          game_id: _this.props.game,
        }
        Actions.putQuitTeam(params).then(res => {
          if (res.code == 200) {
            window.location.reload()
          }
        })
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  }

  render() {
    const { columns, data, rewardList } = this.state

    const { teamInfo, rankList } = this.props.otherTeam ? this.state : this.props

    const { userInfo, otherTeam } = this.props

    const { getFieldDecorator } = this.props.form;
    return (
      <div className="team_home" id="team_home">
        <div className="user_wrap" >
          <div className="avatar">
            <img src={otherTeam ? this.state.teamInfo.logo_image : teamInfo.logo_image} />
          </div>

          <div className="user_info">
            {this.props.userInfo.game_team_id === this.props.id ? (
              <>
                <div className="info_item">
                  <span className="label">用户昵称：</span>
                  <span className="content">{this.props.userInfo.nickname}</span>
                </div>
                <div className="info_item">
                  <span className="label">战队职务：</span>
                  <span className="content">
                    {ROLES_STR[this.props.userInfo.team_job]}
                  </span>
                </div>
                <div className="info_item">
                  <span className="label">战队威望：</span>
                  <span className="content">{this.props.userInfo.prestige}</span>
                </div>
                <div className="info_item">
                  <span className="label">入队时间：</span>
                  <span className="content">{this.props.userInfo.join_time}</span>
                </div>
              </>
            ) : ''}

            <div className="info_btn">
              {otherTeam && (
                <>
                  <div>
                    <Button type="primary"
                      style={{ marginRight: '10px' }}
                      onClick={() => this.setState({
                        visibleForm: true
                      })}>
                      加入战队
                    </Button>

                    <Button type="primary"
                      onClick={() => this.props.onGoList()}>
                      返回列表
                    </Button>
                  </div>
                </>
              )}
              {this.props.userInfo.game_team_id === this.props.id && userInfo.role !== NONE && !otherTeam ? (
                <>
                  <div>
                    <Button type="primary" style={{ marginRight: '10px' }} onClick={this.showModal}>战队奖励</Button>
                    {
                      (this.props.role === 'CAPTAIN' || this.props.role === 'VICE_CAPTAIN')
                      && <Button type="primary" onClick={() => this.props.onGoForm()} >基础信息</Button>
                    }
                    {this.props.role !== CAPTAIN ? <Button type="danger" style={{ marginRight: '10px' }} onClick={this.handleExitTeam}>退出战队</Button> : ''}
                  </div>
                </>
              ) : (
                ''
              )}

            </div>
          </div>
        </div>

        <div className="team_wrap">
          <div className="team_name">{teamInfo.team_name}</div>
          <div className="team_info">
            <div className="info_item">
              <span className="label">队长：</span>
              <span className="content">{teamInfo.team_leader}</span>
            </div>
            <div className="info_item">
              <span className="label">成员数：</span>
              <span className="content">
                {teamInfo.member_count}
/
                {teamInfo.max_member_count}
              </span>
            </div>
            <div className="info_item">
              <span className="label">创建时间：</span>
              <span className="content">{teamInfo.create_time && teamInfo.create_time.split('T')[0]}</span>
            </div>
          </div>
          <div className="exp info_item">
            <span className="label">战队经验：</span>
            <span className="content">
              <Progress strokeColor="#70A401" percent={teamInfo.up_team_xp} />
            </span>

          </div>
          <div className="achievement ">
            战队成就：
            {teamInfo.badge_list && teamInfo.badge_list.map(v => {
              return <img src={medalObj[v.badge_id]} key={v.badge_id} title={v.badge_name} alt={v.badge_name} />
            })}
          </div>
          <div className="announcement_wrap">
            <Tabs defaultActiveKey="1" onChange={this.callback}>
              <TabPane tab="战队公告" key="1" className="content">
                {teamInfo.team_bulletin}
              </TabPane>
              <TabPane tab="战队口号" key="2" className="content">
                {teamInfo.team_slogan}
              </TabPane>
              <TabPane tab="战队简介" key="3" className="content">
                {teamInfo.team_desc}
              </TabPane>
            </Tabs>
          </div>
        </div>
        <div className="leaderboard">
          <div className="title">
            威望榜
          </div>
          <div className="table">
            <table>
              <tbody>
                {rankList.map((v, i) => (
                  <tr key={v.user_id} className={`${i < 3 ? 'green' : ''}`}>
                    <td className="table_id "><span className={`table_index top_${i + 1}`}>{i + 1}</span></td>
                    <td className="table_name">{v.nickname}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <Modal
          className="home_reward_wrap"
          title="战队奖励"
          visible={this.state.visible}
          footer={null}
          getcontainer={false}
          // onOk={this.handleOk}
          onCancel={() => this.setState({
            visible: false
          })}
        >
          <Table
            // bordered
            // title={() => '我的名次'}
            size="small"
            columns={columns}
            dataSource={rewardList}
            // pagination={{"pageSize": 10}}
            scroll={{ y: 240 }} />
        </Modal>

        <Modal
          className="verified_modal"
          title="提交入队申请"
          visible={this.state.visibleForm}
          footer={null}
          getcontainer={false}
          // onOk={this.handleOk}
          onCancel={() => this.setState({
            visibleForm: false
          })}
        >
          <Form {...formItemLayout} onSubmit={this.handleSubmit} className="login-form">
            <Form.Item label="姓名">
              {getFieldDecorator('real_name', {
                rules: [{ required: true, message: '请输入姓名!' }],
              })(
                <Input
                // placeholder="姓名"
                />,
              )}
            </Form.Item>
            <Form.Item label="身份证">
              {getFieldDecorator('identity_number', {
                rules: [{ required: true, message: '请输入身份证!' }],
              })(
                <Input
                // placeholder="身份证"
                />,
              )}
            </Form.Item>
            <Form.Item label="手机号">
              {getFieldDecorator('telephone', {
                rules: [{ required: true, message: '请输入手机号!' }],
              })(
                <Input
                  maxLength={11}
                // placeholder="手机号"
                />,
              )}
            </Form.Item>
            <Form.Item label="QQ">
              {getFieldDecorator('tencent_qq', {
                // rules: [{required: true, message: '请输入手机号!'}],
              })(
                <Input
                  placeholder="QQ"
                />,
              )}
            </Form.Item>
            <Form.Item label="申请理由">
              {getFieldDecorator('self_info', {
                rules: [{ required: true, message: '请输入申请理由!' }],
              })(
                <TextArea allowClear placeholder="申请理由少于100个中文字" maxLength={100} />
              )}
            </Form.Item>

            <Form.Item {...formTailLayout}>
              <Button type="primary" htmlType="submit" className="login-form-button">
                加入
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default Info;
